import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-xs font-medium text-gray-500 float-right text-justify leading-4 mt-1"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmartFormRepeaterItem = _resolveComponent("SmartFormRepeaterItem")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_InputTextHelper = _resolveComponent("InputTextHelper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "grid gap-x-4 gap-y-3",
      style: _normalizeStyle(`grid-template-columns: repeat(${_ctx.item.items.length}, minmax(0, 1fr)) 50px;`)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.items, (item) => {
        return (_openBlock(), _createElementBlock("label", {
          key: item.id,
          class: "block text-sm text-gray-500 font-medium"
        }, [
          _createTextVNode(_toDisplayString(item.label) + " ", 1),
          (item.optional)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('platform.common.optional')), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: `${rowIndex}-${_ctx.item.id}`
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.items, (item) => {
            return (_openBlock(), _createBlock(_component_SmartFormRepeaterItem, {
              key: `${rowIndex}-${item.id}`,
              modelValue: _ctx.rows[rowIndex][item.id],
              "onUpdate:modelValue": [($event: any) => ((_ctx.rows[rowIndex][item.id]) = $event), _ctx.emitInputEvent],
              readonly: _ctx.readonly,
              item: item,
              error: _ctx.rowItemError(rowIndex, item.id),
              "form-submission-id": _ctx.formSubmissionId,
              onChange: _ctx.emitChangeEvent
            }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "item", "error", "form-submission-id", "onChange"]))
          }), 128)),
          (!_ctx.isRequired || _ctx.rows.length > 1)
            ? (_openBlock(), _createBlock(_component_BaseButton, {
                key: 0,
                "data-dusk": `repeater-item-delete-${rowIndex}`,
                class: _normalizeClass({ invisible: _ctx.readonly }),
                color: "ghost",
                size: "large",
                onClick: ($event: any) => (_ctx.removeRow(rowIndex))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BaseIcon, { name: "delete" })
                ]),
                _: 2
              }, 1032, ["data-dusk", "class", "onClick"]))
            : (_openBlock(), _createElementBlock("div", {
                key: `${rowIndex}-delete-spacer`
              }))
        ], 64))
      }), 128))
    ], 4),
    (!_ctx.readonly)
      ? (_openBlock(), _createBlock(_component_BaseButton, {
          key: 0,
          color: "ghost",
          "left-icon": "add",
          class: "mt-3",
          onClick: _ctx.addRow
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.itemName
          ? _ctx.$t('platform.common.add-', [_ctx.itemName])
          : _ctx.$t('platform.common.add')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (!_ctx.readonly)
      ? (_openBlock(), _createBlock(_component_InputTextHelper, {
          key: 1,
          error: _ctx.error
        }, null, 8, ["error"]))
      : _createCommentVNode("", true)
  ]))
}